import { render, staticRenderFns } from "./CustomerSettings.vue?vue&type=template&id=7347924c&"
import script from "./CustomerSettings.vue?vue&type=script&lang=js&"
export * from "./CustomerSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports